import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// Site::Lp01::Question::Component の Stimulus コントローラ。
// landIeul: Item.tsx の isShow トグル。text / icon の Lp01_on / Lp01_off を切り替える。
const ON = "Lp01_on";
const OFF = "Lp01_off";

class SiteLp01QuestionController extends Controller {
  static targets = ["text", "icon"];

  declare readonly textTarget: HTMLElement;
  declare readonly iconTarget: HTMLElement;

  toggle(): void {
    const show = this.textTarget.classList.contains(OFF);
    [this.textTarget, this.iconTarget].forEach((el) => {
      el.classList.toggle(ON, show);
      el.classList.toggle(OFF, !show);
    });
  }
}

application.register("site--lp01--question", SiteLp01QuestionController);
